module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0012-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("Autopsy Report")]), _vm._v(" "), _c('p', {
    staticClass: "cot"
  }, [_c('strong', [_vm._v("H")]), _vm._v("eads up!” Joe yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I jerked my head up, looking for something to catch. A zombie was flying at me, an ax still in its forehead. Green drool flying out of its mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not catchable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I threw myself to the ground. The zombie flew over me, the feet of its size-thirteen work boots skimming over my back. “That was definitely a ‘hit the floor’ moment, not a ‘heads up,’” I told Joe as I shoved myself to my feet. “And why was that zombie flying? Zombies don’t fly.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“Zombies don’t exist at all. The dead cannot extract energy from consuming gray matter and use ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("it to propel themselves forward in any manner,” Joe answered, doing what he thinks is a hilarious impression of me. “And anyway,” he added, dropping his Frank thing, “this is a haunted house we’re building. It’s a place where anything can happen.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe walked over to the zombie and studied it. “The plastic trick-or-treating pumpkin you added doesn’t really work for me. Unless—were you planning to fill it with brains? Because that would be cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t put the pumpkin in its hand,” I answered. “Chet and I’ve been working on plugging up the leaks in the swamp. I came over to tell you it’s ready for that other creature you made—if you’re sure it’s waterproof.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Definitely. Help me carry it. It’s on the loading dock. I was letting the coat of sealant dry out there,” Joe told me. He grabbed the plastic pumpkin out of the ghost-zombie’s hand as we passed it. Something rattled inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe froze and peered into the pumpkin. “It’s go time,” he told me. He tilted the pumpkin so I could see the video game disc inside. Or what looked like a video game disc. That’s how our missions from ATAC are delivered to us.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“Let’s still go to the loading dock. We can watch it out there,” I suggested. We’d gotten permission ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("to use a building that used to be a grocery store for the haunted house. It was up for sale and wasn’t being used for anything. Plus the haunted house was for UNICEF, which made people want to help us out.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The loading dock was empty, just like I’d figured. When we got out there, Joe snapped the disc into his portable game player. The photo of a laughing teenage girl filled the screen. "), _c('em', [_vm._v("“This is Maryama Soll,”")]), _vm._v(" the voice of our ATAC contact began. "), _c('em', [_vm._v("“She was sentenced to a six-week stay at the Undercliff House of Detention in Glastonbury, Connecticut, after repeated incidents of shoplifting. She never made it out of the detention center. Before the six weeks were up, Maryama died there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("“The coroner was unable to determine the cause of death.”")]), _vm._v(" Maryama’s picture was replaced on the screen by her autopsy report. "), _c('em', [_vm._v("“She seemed to be in good health and free from obvious trauma or toxins. However, her blood work showed unusually high amounts of adrenaline and CRH—the brain’s hypothalamic stress hormone. In an off-the-record comment to a homicide detective, the coroner stated that it was almost as if Maryama had been frightened to death.”")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The autopsy report faded, and one of Maryama’s autopsy photos took its place. “Whoa,” Joe whispered. My stomach did a slow roll in my belly. Maryama didn’t look anything like the laughing girl ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("in the first picture anymore. Her face was frozen in an expression of total terror, her mouth open in what looked like a scream, her eyes open so wide you could see the whites all the way around her irises.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The autopsy report of Gregory Teeter was very similar. No obvious cause of death. High amounts of adrenaline and CRH. A newspaper photo of a serious-looking boy flashed on the screen, quickly followed by a photo of the same boy on an autopsy table, his face twisted into a grimace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("“There are rumors among the teens living at the Undercliff House of Detention that the place is haunted,”")]), _vm._v(" our contact went on. A video clip of a bunch of kids playing soccer in front of a huge stone building appeared on the screen. Undercliff, obviously. I don’t believe in ghosts. But if I did, that heap of gray stone looked like exactly the kind of place a ghost would live. Afterlive? "), _c('em', [_vm._v("“Even some of the people living in Glastonbury seem to believe there is something evil about the place. The rumors may have had their start in Undercliff’s history. When it was built in 1794, it was used as an insane asylum, and many of the patients there were badly mistreated.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s exactly the kind of place that would be haunted,” Joe said. “A place where there’s been a lot of pain.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("“Joe, that’s not—,” I began. I didn’t have to tell him that ATAC wasn’t giving us the assignment of dealing with ghosts. Our contact did it for me. "), _c('em', [_vm._v("“Clearly, there is a rational explanation for the deaths of Maryama Soll and Gregory Teeter,”")]), _vm._v(" he said as the video clip continued to play. "), _c('em', [_vm._v("“Your mission is to find out who is responsible for their deaths.”")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("My eyes locked on all those kids playing soccer. Joe and I needed to work fast. We had to find out what was really going on at Undercliff before one of them ended up dead too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The screen went blank. If we tried to play it again, it would probably blast out a Jessica Simpson song. We got only one chance to watch our mission assignment, for security reasons. “Anything else in the pumpkin?” I asked Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Some undercover background info for us,” he answered. “Train tickets. And this.” He pulled out a worn piece of paper. “It says it was in Maryama’s pocket when she died.”")]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('em', [_vm._v("Wednesday, March 14, 1810")])])]), _c('p', {
    staticClass: "txb1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('em', [_vm._v("I keep my mind on happy moments. A walk by the lake with the dogs. I see a nest with a wren on it. I eat leaning against a stone wall. A night dining at the home of Mr. Werry. Chess afterward. A day with a letter from Charlotte. Weeding the turnips, with ")])]), _c('em', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("my hands in the warm earth. Fishing in moonlight. Lying in my own bed.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "txb"
  }, [_c('em', [_vm._v("But the screams tear the memories from my head. Its never silent here. There is always someone screaming in fear, whether real or imaginary. Does it really matter which? Pain is pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('em', [_vm._v("I am Moses Bottelle. I do not belong here. I tell myself that again and again. I am Moses Bottelle. I do not belong here. I will not allow myself to become a screaming one. I will go over my happy memories. I will stay sane. I will not scream. I will not become one of them simply because I am surrounded by them.")])]), _vm._v(" "), _c('p', {
    staticClass: "txb"
  }, [_c('em', [_vm._v("I will not scream.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36490eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/004.vue
// module id = 66
// module chunks = 0